import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class DownTimeReasonDto{
    @ApiProperty()
    @IsNotEmpty({message:"DowntimeReasonId should not be empty"})
    @IsAlphanumeric()
    @IsOptional()
    downtimereasonId?: number;



    @ApiProperty()
  @IsNotEmpty({message:"Reason should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  downtimeReason: string;



    @ApiProperty()
  @IsNotEmpty({message:"Status should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  downtimestatus: string;

  @ApiProperty()
  @IsNotEmpty({message:"expected time must be enter"})
  sla:number;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;


}